import {SectionTitle} from '@/components/molecules'
import {PageContainer} from '@/components/organisms'
import {useFeatureFlagLanguages} from '@/hooks/useFeatureFlagLanguages'

const DisplayInformation = ({productData}) => {
  const languages = useFeatureFlagLanguages()

  return (
    <div className="productoverview-brand-category">
      <SectionTitle id={'Display Information'} label="Display Information" />
      <div className="sc-border grid grid-cols-3 gap-2 pb-1"></div>

      {languages.map(lang => {
        const languageName = lang.language
        const language = lang.code

        return (
          <div key={language}>
            <div className="language-wrapper pt-5">{languageName}</div>

            <div className="sc-border grid grid-cols-3 gap-4 pb-5">
              <div className="col-4 pt-5">
                <span className="key">Display Name</span>
                <h2 className="val">{productData?.displayName?.[language] || '-'}</h2>
              </div>
              <div className="col-4 pt-5">
                <span className="key">Display Size</span>
                <h2 className="val">{productData?.displaySize?.[language] || '-'}</h2>
              </div>
              <div className="col-4 pt-5">
                <span className="key">Product Flavor</span>
                <h2 className="val">{productData?.flavor?.[language] || '-'}</h2>
              </div>
              <div className="col-4 pt-5">
                <span className="key">Short Description</span>
                <h2 className="val">{productData?.shortDescription?.[language] || '-'}</h2>
              </div>
              <div className="col-4 pt-5">
                <span className="key">Long Description</span>
                <h2 className="val">{productData?.longDescription?.[language] || '-'}</h2>
              </div>
              <div className="col-4 pt-5">
                <span className="key">Keywords</span>
                <h2 className="val">{productData?.keywords?.[language] || '-'}</h2>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export const ProductDisplayBlock = ({productData}) => {
  if (!productData) {
    return (
      <PageContainer>
        <div>No display data available</div>
      </PageContainer>
    )
  }

  return (
    <PageContainer>
      <DisplayInformation productData={productData} />
    </PageContainer>
  )
}

export default ProductDisplayBlock
